import { NotificationService } from './../../services/notification.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
@Component({
  selector: 'app-password-recovery',
  templateUrl: './password-recovery.component.html',
  styleUrls: ['./password-recovery.component.scss']
})
export class PasswordRecoveryComponent implements OnInit {
  newPassword: string;
  confirmPassword: string;
  email: string;
  securityKey: string;
  currentUrl: any;

  constructor(
    private routes: ActivatedRoute,
    private http: HttpClient,
    private notificationService: NotificationService,
    private router: Router
  ) {
    this.currentUrl = window.location.origin;

  }
  ngOnInit() {
    this.email = this.routes.snapshot.queryParams.email;
    this.securityKey = this.routes.snapshot.queryParams.activationCode;
  }

  updatePassword(form: NgForm) {
    if (form.value.newPassword !== form.value.confirmPassword) {
      this.notificationService.show('error', `Password and confirmation don't match`);
      return;
    }

    const inputJson = {
      emailAddress: this.email,
      activationCode: this.securityKey,
      encryptedPassword: form.value.newPassword,
      partnerId: JSON.parse(localStorage.getItem('partnerDetail')).partnerId
    };

    this.http.post(`${this.currentUrl}/api/api/shared/password/set`, inputJson)
      .subscribe(() => {
        this.notificationService.show('success', ' Password Update Successful. Please login');
        this.router.navigate(['/login']);
      },
      () => {
        this.notificationService.show('error', 'Error while changing password');
      });
  }

  cancel() {
    this.router.navigateByUrl('/login')
  }
}
